<template>
  <div class="report__block-header">
    <div class="report__block-header-left">
      <div class="report__block-header-title">
        {{ title }}
      </div>
    </div>
    <div>
      <transition
        appear
        name="fade"
      >
        <div
          v-if="
            !getPurchasedInfo[type] && !getIsLegacy && !isMobile
          "
          class="block-header__buy-wrapper"
        >
          <BuyButton
            v-if="type !== 'address'"
            :type="type"
          />
          <div
            v-if="type == 'tier2'"
            class="block-header__buy-text"
          >
            Money Trail + Risk Score
          </div>
          <div
            v-if="type == 'full'"
            class="block-header__buy-text"
          >
            Full Report
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// components
import BuyButton from '@/pages/report/components/section-components/BuyButton'
// vuex
import { mapGetters } from 'vuex'
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'ReportBlockHeader',
  components: {
    BuyButton,
  },
  mixins: [deviceWidthMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    purchasedPartInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('report', [
      'getPurchasedInfo',
      'getIsLegacy',
    ]),
  },
}
</script>

<style>
.report__block-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
}
.report__block-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 767px) {
  .report__block-header {
    flex-direction: column;
  }
}
</style>

<style scoped>
.block-header__buy-wrapper {
  position: relative;
}
.block-header__buy-text {
  position: absolute;
  width: 100%;
  margin-top: 6px;
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  text-align: center;
  font-size: var(--Size-S, 12px);
  font-weight: 500;
  line-height: var(--Line-Height-S, 16px);
}
</style>
